import styled from "styled-components";

const Wrapper = styled.div`
    
    *{
        font-family : McKinsey Sans !important;
    }
    position : fixed;
    width : 100%;
    height : 100%;
    
    background : rgba(0,0,0,0.3);
    z-index : 11;
    top : 0;
    left : 0;
    display : flex;
    align-items : center;
    justify-content : center;
    h1{
        margin : 0;
        margin-bottom : 20px;
        font-size : 1.2rem;
    }
    section{
        width : 400px;
        height : 200px;
        background : #fff;
        padding : 30px;
        box-sizing : border-box;
        border-radius : 2px;
        position : relative;
        &.loading:before{
            position : absolute;
            content : "";
            width : 50px;
            left : 0;
            top : 0;
            height : 5px;
            background : #0021ff;
            animation : run 1s linear infinite;
        }
        @keyframes run{
            from {
                transform : translateX(0)
            }
            to{
                transform : translateX(350px)
            }
        }
        select{
            padding : 10px 20px;
            width : 100%;
        }
        input{
            display : block !important;
            margin : 20px auto;
        }
    }
`

export default Wrapper